import React, { useState, useEffect, useRef, useCallback } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import { toCanvas } from "html-to-image";
// import Save from "../../../../assets/image/icon/download.png"
// import Saved from "../../../../assets/image/icon/download_reverse.png"
import Save from "../../../../assets/icons/System/download_inversed.svg"
import Saved from "../../../../assets/icons/System/download_inversed.svg"
import { useToast } from "../../../../hooks/useToast";
import { useAddAIGeneratedWatermark } from "../../../../hooks/useAddAIGeneratedWatermark"

// title, useOption 값에 따라 폴더명을 변환하는 매핑 객체
const titleMap = {
  1: "intro",
  2: "intro",
  3: "event",
};

const useOptionMap = {
  1: "4to7",
  2: "4to7",
  3: "1to1",
  4: "1to1",
  5: "4to7",
  6: "1to1",
  7: "1to1",
  "문자메시지": "4to7",
  "": "4to7",

};

const AdsSwiper = ({
  imageTemplateList,
  content,
  title,
  useOption,
  // checkImages,
  // checkedBox,
  handleImageClick,
  storeName,
  roadName,
  weather,
  tag,
  weekday,
  autoUpload = false,
  onAutoUpload,
  toastBottomOffset
}) => {
  const [templates, setTemplates] = useState([]);
  const [savedMap, setSavedMap] = useState({});

  const [pendingSaveId, setPendingSaveId] = useState(null);
  const [saveLoading, setSaveLoading] = useState(false)

  const [autoUploaded, setAutoUploaded] = useState(false);

  const { showToast } = useToast();
  const [activeIndex, setActiveIndex] = useState(0);

  const originalSlideIndex = templates.length;
  const isActiveOriginal = activeIndex === originalSlideIndex;
  // const isNeighborOriginal = Math.abs(activeIndex - originalSlideIndex) === 1;


  // title, useOption 값을 변환하여 템플릿 경로 결정
  const folderTitle = titleMap[title] || title;
  const folderUseOption = useOptionMap[useOption] || useOption;
  // const couponImgUrl = require("../../../../assets/image/icon/coupon.png");

  const swiperRef = useRef(null);
  const initialSyncedRef = useRef(false); // 🔹 맨 위 useRef 하나 추가

  // 템플릿 박스 크기 기록
  const templateBoxRef = useRef(null);
  const [templateBoxSize, setTemplateBoxSize] = useState(null);

  const addWatermark = useAddAIGeneratedWatermark();

  useEffect(() => {
    if (!templateBoxRef.current) return;
    const rect = templateBoxRef.current.getBoundingClientRect();
    setTemplateBoxSize({
      width: rect.width,
      height: rect.height,
    });
  }, [templates.length]);

  // 🔹 미리보기용 워터마크 스타일 (저장용 캔버스와 비슷하게 스케일)
  const watermarkStyle = templateBoxSize
    ? (() => {
      const scale = templateBoxSize.width / 1080; // 저장용과 동일 기준
      const fontSize = 24 * scale;
      const margin = 44 * scale;

      return {
        fontSize: `${fontSize}px`,
        right: `${margin}px`,
        bottom: `${margin}px`,
        textShadow: "0 0 2px rgba(0,0,0,0.35)",
      };
    })()
    : undefined;


  useEffect(() => {
    const loadTemplates = async () => {
      try {
        const templateModules = [];
        for (let i = 1; i <= 10; i++) {
          if (folderTitle === "intro" && folderUseOption === "4to7" && (i === 1 || i === 2 || i === 3 || i === 4)) continue; // template_intro_4to7_1, 3 템플릿은 제외
          if (folderTitle === "intro" && folderUseOption === "1to1" && (i === 1 || i === 3 || i === 6 || i === 7)) continue;
          if (folderTitle === "event" && folderUseOption === "1to1" && (i === 1 || i === 2)) continue;
          if (folderTitle === "event" && folderUseOption === "4to7" && (i === 1 || i === 2 || i === 5)) continue;
          try {
            const module = await import(`../../../../pages/Ads/template/${folderTitle}/${folderUseOption}/Template${i}.jsx`);
            templateModules.push({ id: i, Component: module.default });
          } catch (error) {
            if (error.message.includes("Cannot find module")) {
              continue; // 파일이 없으면 건너뜀
            } else {
              throw error; // 다른 오류는 그대로 발생
            }
          }
        }
        setTemplates(templateModules);
      } catch (error) {
        console.error("템플릿을 불러오는 중 오류 발생:", error);
      }
    };

    loadTemplates();
  }, [folderTitle, folderUseOption]); // ✅ `useEffect`의 의존성을 최소화하여 ESLint 경고 해결

  // ✅ 추가: 템플릿이 늦게 로드될 때 초기 선택 보정
  useEffect(() => {
    if (!swiperRef.current || templates.length === 0) return;
    if (initialSyncedRef.current) return; // 이미 한 번 돌았으면 종료

    const s = swiperRef.current;
    const total = templates.length + 1;      // 템플릿 N + 원본 1
    const real = s.realIndex % total;        // loop와 무관한 실제 인덱스
    const isOriginal = real === templates.length;
    const id = isOriginal ? 0 : templates[real]?.id;

    handleImageClick(id);
    setActiveIndex(real);
    initialSyncedRef.current = true; // 다시는 안 돌게
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [templates]); // 🔥 handleImageClick 의존성 제거


  // 특정 템플릿 ID를 캡처해서 dataURL(JPEG) 반환
  const captureTemplateToDataUrl = useCallback(async (id) => {
    let dataUrl = null;

    // 🔹 원본(id === 0)은 여기서는 안 쓸 예정 (자동업로드는 템플릿만)
    if (id === 0) {
      return null;
    }

    let cursorElements = null;
    let editableElements = null;

    // onSave와 동일한 titlePath/useOptionPath 계산
    let useOptionPath = "";
    let titlePath = "";
    const normalizedTitle = String(title);
    const normalizedUseOption = String(useOption);

    if (["1", "매장 홍보", "상품 소개", "2"].includes(normalizedTitle)) {
      titlePath = "intro";
    } else if (["3", "이벤트"].includes(normalizedTitle)) {
      titlePath = "event";
    }

    if (["1", "인스타스토리", "스토리", "카카오톡", "2", "인스타 스토리"].includes(normalizedUseOption)) {
      useOptionPath = "4to7";
    } else if (["3", "인스타그램", "인스타", "피드", "네이버 밴드", "밴드", "네이버밴드", "6"].includes(normalizedUseOption)) {
      useOptionPath = "1to1";
    }

    const templateElement = document.getElementById(
      `template_${titlePath}_${useOptionPath}_${id}`
    );
    if (!templateElement) {
      console.error("템플릿 요소를 찾을 수 없습니다. (autoUpload)");
      return null;
    }

    try {
      // 커서/에디터 보더 제거
      cursorElements = templateElement.querySelectorAll(".blinking-cursor");
      cursorElements.forEach((el) => {
        el.classList.remove("blinking-cursor");
        el.classList.add("no-blinking");
      });

      editableElements = templateElement.querySelectorAll(".editable-text");
      editableElements.forEach((el) => {
        el.setAttribute("data-prev-border", el.style.border || "");
        el.style.border = "none";
      });

      const key = `template_${titlePath}_${useOptionPath}_${id}`;
      const exporter = window.__templateExports?.[key];

      if (typeof exporter === "function") {
        // 캔버스 직접 합성 방식
        dataUrl = await exporter();
      } else {
        // html-to-image 방식
        const canvas = await toCanvas(templateElement, {
          width: templateElement.offsetWidth * 2,
          height: templateElement.offsetHeight * 2,
          style: {
            transform: "scale(2)",
            transformOrigin: "top left",
          },
          cacheBust: true,
        });
        dataUrl = canvas.toDataURL("image/jpeg", 0.9);
      }

      return dataUrl;
    } catch (e) {
      console.error("captureTemplateToDataUrl error:", e);
      return null;
    } finally {
      // 커서/보더 원복
      if (cursorElements) {
        cursorElements.forEach((el) => {
          el.classList.remove("no-blinking");
          el.classList.add("blinking-cursor");
        });
      }

      if (editableElements) {
        editableElements.forEach((el) => {
          el.style.border = el.getAttribute("data-prev-border") || "";
          el.removeAttribute("data-prev-border");
        });
      }
    }
  }, [title, useOption]);

  // 🔥 자동 업로드: 템플릿 중 하나를 랜덤으로 골라 캡처 후 onAutoUpload 호출
  useEffect(() => {
    if (!autoUpload) return;           // 자동 업로드 모드가 아니면 패스
    if (autoUploaded) return;          // 이미 한 번 업로드했으면 재실행 방지
    if (!templates || templates.length === 0) return;
    if (!onAutoUpload) return;
    if (!imageTemplateList || imageTemplateList.length === 0) return;

    // 원본 슬라이드는 templates에 포함 X → 템플릿들 중에서만 랜덤
    const randomIndex = Math.floor(Math.random() * templates.length);
    const randomTemplateId = templates[randomIndex].id;

    (async () => {
      try {
        const dataUrl = await captureTemplateToDataUrl(randomTemplateId);
        if (!dataUrl) return;

        const watermarkedDataUrl = await addWatermark(dataUrl);
        setAutoUploaded(true); // 중복 실행 방지

        // 부모(ConciergeSystemList)로 콜백
        onAutoUpload({
          templateId: randomTemplateId,
          imageDataUrl: watermarkedDataUrl,
          // 텍스트는 content prop 그대로 사용
          copyrightText: content,
        });
      } catch (e) {
        console.error("autoUpload failed:", e);
      }
    })();
  }, [autoUpload, autoUploaded, templates, onAutoUpload, content, imageTemplateList, captureTemplateToDataUrl, addWatermark]);


  const handleSaveClick = async (id) => {
    setPendingSaveId(id);
    setSaveLoading(true);

    try {
      await onSave(id);  // 실제 이미지 저장

      setSavedMap((prev) => ({
        ...prev,
        [id]: true,
      }));

      // 저장 성공 토스트
      showToast("이미지를 저장했습니다", {
        placement: "bottom",
        bottomOffset: toastBottomOffset,
      });
    } catch (e) {
      console.error("이미지 저장 실패:", e);
      // 필요하면 실패 토스트도 추가 가능
      // showToast("이미지 저장에 실패했습니다.");
    } finally {
      setSaveLoading(false);
    }
  };



  // 유틸: 이미지 URL → base64 (fetch 시도 후 실패하면 canvas로 폴백)
  async function imageUrlToBase64(src) {
    // 이미 data URL이면 그대로 반환
    if (typeof src === "string" && src.startsWith("data:")) return src;
    // 1) fetch -> blob -> FileReader
    try {
      const res = await fetch(src, { cache: "no-store" });
      const blob = await res.blob();
      const base64 = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
      return base64; // "data:image/...;base64,...."
    } catch (_) {
      // 2) canvas 폴백 (서버가 CORS 허용해야 동작)
      await new Promise((r) => setTimeout(r, 0));
      const img = new Image();
      img.crossOrigin = "anonymous";
      img.decoding = "async";
      img.referrerPolicy = "no-referrer";
      const base64 = await new Promise((resolve, reject) => {
        img.onload = () => {
          try {
            const canvas = document.createElement("canvas");
            canvas.width = img.naturalWidth;
            canvas.height = img.naturalHeight;
            const ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0);
            resolve(canvas.toDataURL("image/png", 1.0));
          } catch (e) {
            reject(e);
          }
        };
        img.onerror = reject;
        img.src = src;
      });
      return base64;
    }
  }



  const onSave = async (id) => {
    const index = id;

    let useOptionPath = "";
    let titlePath = "";
    const normalizedTitle = String(title);
    const normalizedUseOption = String(useOption);

    if (["1", "매장홍보", "상품소개", "2"].includes(normalizedTitle)) {
      titlePath = "intro";
    } else if (["3", "이벤트"].includes(normalizedTitle)) {
      titlePath = "event";
    }

    if (["1", "인스타스토리", "스토리", "카카오톡", "2", "인스타 스토리"].includes(normalizedUseOption)) {
      useOptionPath = "4to7";
    } else if (["3", "인스타그램", "인스타", "피드", "네이버 밴드", "밴드", "네이버밴드", "6"].includes(normalizedUseOption)) {
      useOptionPath = "1to1";
    }

    let cursorElements = null;
    let editableElements = null;

    try {
      if (id === 0) {
        // ✅ 원본도 템플릿과 동일하게: Base64로 네이티브에 전달
        const imageUrl = imageTemplateList[0];
        const base64 = await imageUrlToBase64(imageUrl);
        const watermarkedBase64 = await addWatermark(base64);
        const filename = `original_image_${Date.now()}.png`;
        if (window.ReactNativeWebView?.postMessage) {
          // 네이티브에서 MediaStore에 저장
          // (필요 시 두 번째 파라미터로 파일명 전달하도록 네이티브 시그니처 확장 권장)
          try {
            window.ReactNativeWebView.postMessage(
              JSON.stringify({
                type: "DOWNLOAD_IMAGE",
                payload: { dataUrl: watermarkedBase64, filename },
              })
            );
          } catch {
            alert("이미지 저장 실패")
            // 구 시그니처(파라미터 1개) 호환
            window.Android.saveCapturedImageBase64(watermarkedBase64);
          }
        } else {
          // 브라우저 환경 폴백: 다운로드
          const a = document.createElement("a");
          a.href = watermarkedBase64;
          a.download = filename;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        }
      } else {
        // 템플릿 캡처 → dataURL(JPEG) 생성
        const templateElement = document.getElementById(`template_${titlePath}_${useOptionPath}_${index}`);
        if (!templateElement) {
          console.error("템플릿 요소를 찾을 수 없습니다.");
          return;
        }

        cursorElements = templateElement.querySelectorAll(".blinking-cursor");
        cursorElements.forEach((el) => {
          el.classList.remove("blinking-cursor");
          el.classList.add("no-blinking");
        });

        editableElements = templateElement.querySelectorAll(".editable-text");
        editableElements.forEach((el) => {
          el.setAttribute("data-prev-border", el.style.border || "");
          el.style.border = "none";
        });

        // let iconElement = null;
        // if (checkedBox) {
        //   iconElement = document.createElement("img");
        //   iconElement.src = couponImgUrl;
        //   iconElement.className = "w-16 h-16 object-contain";
        //   iconElement.style.position = "absolute";
        //   iconElement.style.bottom = "28px";
        //   iconElement.style.right = "20px";
        //   iconElement.style.zIndex = "99";

        //   templateElement.style.position = "relative"; // 템플릿 요소에 position relative 추가
        //   templateElement.appendChild(iconElement);
        // }

        let dataUrl = null;
        let filename = `template_image_${index}_${Date.now()}.jpg`;

        // 🔸 1) 특정 키만 캔버스 합성(exporter) 사용
        const key = `template_${titlePath}_${useOptionPath}_${index}`; // 예: template_event_4to7_5
        const exporter = window.__templateExports?.[key];

        // if ((key === "template_event_4to7_5" || key === "template_event_1to1_3") && typeof exporter === "function") {
        if (typeof exporter === "function") {
          // ✅ 새 방식: 배경+그라데이션+텍스트 모두 캔버스에서 직접 합성
          dataUrl = await exporter(); // JPEG dataURL 반환
        } else {
          // ✅ 기존 방식 유지: html-to-image → toCanvas
          // (필요하면 transform scale(2) 같은 옵션은 제거하고 pixelRatio 사용)
          const canvas = await toCanvas(templateElement, {
            width: templateElement.offsetWidth * 2,
            height: templateElement.offsetHeight * 2,
            style: {
              transform: "scale(2)",
              transformOrigin: "top left",
            },
            cacheBust: true,
            // style: { /* transform 제거 권장 */ },
          });
          dataUrl = canvas.toDataURL("image/jpeg", 0.9);
        }
        const watermarkedDataUrl = await addWatermark(dataUrl);

        // 🔸 2) RN(WebView)로 전송 또는 브라우저 저장 (기존 그대로)
        if (window.ReactNativeWebView?.postMessage) {
          window.ReactNativeWebView.postMessage(
            JSON.stringify({
              type: "DOWNLOAD_IMAGE",
              payload: { dataUrl: watermarkedDataUrl, filename },
            })
          );
        } else {
          const a = document.createElement("a");
          a.href = watermarkedDataUrl;
          a.download = filename;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        }
      }

    } catch (err) {
      console.error("저장 중 오류 발생:", err);
    } finally {
      if (cursorElements) {
        cursorElements.forEach((el) => {
          el.classList.remove("no-blinking");
          el.classList.add("blinking-cursor");
        });
      }

      if (editableElements) {
        editableElements.forEach((el) => {
          el.style.border = el.getAttribute("data-prev-border") || "";
          el.removeAttribute("data-prev-border");
        });
      }
    }
  };







  if (!imageTemplateList || imageTemplateList.length === 0) {
    return (
      <div className="flex flex-col justify-center items-center rounded-[16px] text-white pb-4">
        <p>이미지가 없습니다.</p>
      </div>
    );
  }

  return (
    <div className="flex flex-col justify-center items-center rounded-[16px] text-white pt-[8px]">
      <Swiper
        modules={[Pagination]}
        onSwiper={(s) => (swiperRef.current = s)} // 인스턴스 보관
        onAfterInit={(s) => {
          const total = templates.length + 1;      // 템플릿 N + 원본 1
          const real = s.realIndex % total;        // loop와 무관한 실제 인덱스
          const isOriginal = real === templates.length;
          const id = isOriginal ? 0 : templates[real]?.id;
          setActiveIndex(real);
          handleImageClick(id);
        }}
        pagination={{
          el: ".custom-pagination",
          clickable: true,
          bulletClass: "custom-bullet",
          bulletActiveClass: "custom-bullet-active",
        }}
        className="w-full h-full relative"
        loop={false}
        slidesPerView={"auto"}          // ✅ 그대로 유지
        centeredSlides={true}           // ✅ 추가
        spaceBetween={16}               // ✅ 카드 사이 간격
        onSlideChange={(swiper) => {
          // const index = swiper.realIndex; // 현재 슬라이드 인덱스
          // const id = index === 0 ? 0 : templates[index - 1]?.id; // 첫 슬라이드는 원본이므로 id 0
          const total = templates.length + 1;      // 템플릿 N + 원본 1
          const real = swiper.realIndex % total;   // loop 복제와 무관한 실제 인덱스
          const isOriginal = real === templates.length; // 마지막이 원본
          const id = isOriginal ? 0 : templates[real]?.id;
          handleImageClick(id); // ✅ 자동 실행
          setActiveIndex(real);
        }} //onSlideChange 추가됨
      // slidesPerView={"auto"}
      // centeredSlides={true}
      // spaceBetween={30}
      >
        {/* 동적 템플릿 */}
        {templates.map(({ id, Component }, idx) => {
          const slideIndex = idx;                          // 0 ~ templates.length-1
          const isActive = activeIndex === slideIndex;

          return (
            <SwiperSlide
              key={id}
              data-kind="template"
              data-tplid={id}
              className="flex justify-center"
              style={{ width: "80%", maxWidth: "420px" }}
            >
              {/* 🔹 카드 래퍼: 라운드 + 오버플로우 + 고정 크기 + border 4px */}
              <div
                ref={idx === 0 ? templateBoxRef : null}
                className={[
                  "relative flex justify-center items-center",
                  "rounded-[12px] overflow-hidden",
                  "border-[4px] border-transparent",      // 두께는 항상 4px, 기본은 투명
                  "transition-all duration-200",
                  isActive ? "border-[#4125DD]" : "", // 현재 슬라이드만 색 보이게
                ].join(" ")}
                style={
                  templateBoxSize
                    ? {
                      width: templateBoxSize.width,
                      height: templateBoxSize.height,
                    }
                    : undefined
                }
                onClick={() => handleImageClick(id)}
              >
                {/* 🔹 실제 캡처 대상: 내용만 채운다 */}
                <div
                  id={`template_${folderTitle}_${folderUseOption}_${id}`}
                  className="w-full h-full"
                >
                  <Component
                    imageUrl={imageTemplateList[0]}
                    text={content}
                    storeName={storeName}
                    roadName={roadName}
                    weather={weather}
                    tag={tag}
                    weekday={weekday}
                  />
                </div>

                {/* 저장 버튼 */}
                <div
                  className="absolute top-3 right-3 flex justify-center items-center cursor-pointer z-10"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleSaveClick(id);
                  }}
                >
                  <div className="flex items-center justify-center w-[24px] h-[24px] rounded-full bg-surface-light-primary">
                    {saveLoading && pendingSaveId === id ? (
                      <img src={Save} alt="save" className="w-[16px] h-[16px]" />
                    ) : savedMap[id] ? (
                      <img src={Saved} alt="saved" className="w-[16px] h-[16px]" />
                    ) : (
                      <img src={Save} alt="save" className="w-[16px] h-[16px]" />
                    )}
                  </div>
                </div>

                {/* 🔹 미리보기용 워터마크 (저장 시 캔버스 워터마크와 위치/크기 맞춤) */}
                {watermarkStyle && (
                  <div
                    className="pointer-events-none absolute text-white z-0"
                    style={watermarkStyle}
                  >
                    Wizmarket AI
                  </div>
                )}

                {/* 쿠폰 프리뷰 */}
                {/* {checkedBox && (
                  <div className="absolute bottom-11 right-5 flex items-center justify-center">
                    <img
                      src={require("../../../../assets/image/icon/coupon.png")}
                      alt="쿠폰"
                      className="w-16 h-16"
                    />
                  </div>
                )} */}
              </div>
            </SwiperSlide>
          );
        })}



        {/* 원본 이미지 */}
        {/* <SwiperSlide key={0}> */}
        <SwiperSlide
          key="original"
          data-kind="original"
          data-tplid="0"
          className="flex justify-center"
          style={{ width: "80%", maxWidth: "420px" }}
        >
          <div
            className={[
              "relative flex justify-center items-center",
              "rounded-[12px] overflow-hidden",
              "border-[4px] border-transparent",
              "transition-all duration-200",
              isActiveOriginal ? "border-[#4125DD]" : "",
            ].join(" ")}
            style={
              templateBoxSize
                ? {
                  width: templateBoxSize.width,
                  height: templateBoxSize.height,
                }
                : undefined
            }
          >
            {/* 원본 카드 내용 */}
            <div className="relative w-full h-full flex items-center justify-center bg-surface-light-subtle">
              <img
                src={imageTemplateList[0]}
                alt="원본"
                className="max-w-full max-h-full object-contain"
              />
            </div>

            <div
              className="absolute top-3 right-3 flex justify-center items-center cursor-pointer z-10"
              onClick={(e) => {
                e.stopPropagation();
                handleSaveClick(0);
              }}
            >
              <div className="flex items-center justify-center w-[24px] h-[24px] rounded-full bg-surface-light-primary">
                {savedMap[0] ? (
                  <img src={Saved} alt="saved" />
                ) : (
                  <img src={Save} alt="save" />
                )}
              </div>
            </div>

            {/* 🔹 원본에도 미리보기용 워터마크 */}
            {watermarkStyle && (
              <div
                className="pointer-events-none absolute text-white z-0"
                style={watermarkStyle}
              >
                Wizmarket AI
              </div>
            )}
          </div>
        </SwiperSlide>



      </Swiper>

      {/* 페이지네이션 */}
      <div className="custom-pagination pt-2 flex justify-center items-center"></div>

    </div>
  );
};

export default AdsSwiper;
